<template>
  <div>
    <el-dialog title="预览" :visible.sync="showDialog" top="20px" append-to-body width="1110px">
      <div class="box">
        <div class="btns">
          <el-dropdown class="dropdown" @command="handleCommandCompany" trigger="click">
            <el-button size="small" type="primary">
              设置公章<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in newPdfImgs" :key="index + 'b'"
                :command="index">添加到第{{ index + 1 }}页</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown class="dropdown" @command="handleCommandPerson" trigger="click">
            <el-button size="small" type="primary">
              设置设置个人章<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in newPdfImgs" :key="index + 'b'"
                :command="index">添加到第{{ index + 1 }}页</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-button size="small" type="primary" :loading="btnLoading" @click="confirm">确定</el-button>
        </div>
        <div class="flex-box">
          <div class="img-view" v-for="(item, index) in newPdfImgs" :key="index + 'a'" :ref="'imgView'">
            <img class="img" :src="item.src" alt="">
            <Seal type="seal_p" ref="seal_p" :left="pLeft" :top="pTop" :maxWidth="item.maxWidth"
              :maxHeight="item.maxHeight" :src="signature.personSign" :index="index"
              @sendCoordinate="receiveCoordinatePerson" v-if="item.seal_p" />
            <Seal type="seal_c" ref="seal_c" :left="cLeft" :top="cTop" :maxWidth="item.maxWidth"
              :maxHeight="item.maxHeight" :src="signature.canpanySign" :index="index"
              @sendCoordinate="receiveCoordinateCompany" v-if="item.seal_c" />
          </div>
        </div>
      </div>
      <!-- 验证密码弹窗 -->
      <VerifyPassword ref="verifyPassword" @checkSuccess="onSeal" />
    </el-dialog>
  </div>
</template>

<script>
import Seal from '@/components/seal.vue';
import VerifyPassword from './verifyPassword';
import { mapGetters } from 'vuex';
import { myConfirm } from '@/utils/tools'
export default {
  components: {
    Seal,
    VerifyPassword
  },
  data() {
    return {
      maxWidth: 520,
      maxHeight: 0,
      cLeft: 50,
      cTop: 50,
      pLeft: 200,
      pTop: 50,
      x: null,
      y: null,
      seal_p_img: require("../../../../assets/seal_p.png"),
      seal_c_img: require("../../../../assets/seal_c.png"),
      newPdfImgs: [
        // {
        //   maxHeight: 0,
        //   maxWidth: 0,
        //   seal_c: false,
        //   seal_p: false,
        //   src: "https://sxgongzhen.oss-cn-hangzhou.aliyuncs.com/bangzhengtest/20200814025059/9aa020e28ac640318dc2866cd3988726.png"
        // }
      ],
      reqParams: {
        zx: '',
        zy: '',
        zpage: '',
        znum: '',
        qx: '',
        qy: '',
        qpage: '',
        qnum: '',
      },
      zpage: 0,    //个人公章在第几页
      znum: 1,//个人公章数量
      qpage: 0,//个人签名在第几页
      qnum: 1,//个人签名数量
      btnLoading: false,
      showDialog: false,
      perviewList: [],
      pdfPath: '',
      dataOption: {},
      contractId: ''
    }
  },
  computed: {
    ...mapGetters({
      pdfImgs: "case/pdfImgs",
      makeCardReqData: 'makeCard/makeCardReqData',
      templateId: 'makeCard/templateId',
      chuzhengId: 'makeCard/chuzhengId',
      signature: 'login/signature',
      action: "makeCard/action"
    }),
  },
  mounted() {
    console.log(this.$store.state.case.pdfImgs);
    // this.newPdfImgs = JSON.parse(JSON.stringify(this.pdfImgs));
    // this.getImageHeight();
  },
  methods: {
    open(option) {
      console.log('option', option)
      this.dataOption = option;
      this.showDialog = true;
      this.pdfPath = option.pdfPath;
      this.contractId = option.contractId;
      this.newPdfImgs = option.pdfImg.map((item, index) => {
        return {
          maxHeight: 520,
          maxWidth: 0,
          seal_c: index === option.pdfImg.length - 1,
          seal_p: index === option.pdfImg.length - 1,
          src: item
        }
      })
      // this.newPdfImgs = [
      //   {
      //     maxHeight: 520,
      //     maxWidth: 0,
      //     seal_c: true,
      //     seal_p: true,
      //     src: option.pdfImg
      //   }
      // ];
      this.getImageHeight(option)
    },
    close() {
      this.showDialog = false;
    },
    // 获取合同图片高度
    getImageHeight() {
      let conArr = this.$refs.imgView;
      let timer = setTimeout(() => {
        this.getImageHeight();
      }, 1000)
      if (conArr) {
        if (conArr[0].offsetHeight > 700) {
          let pIndex = 0;
          let cIndex = 0;
          let qx = this.dataOption.qx;
          let qy = this.dataOption.qy;
          let zx = this.dataOption.zx;
          let zy = this.dataOption.zy;
          let pMaxWidth = conArr[0].offsetWidth;
          let pMaxHeight = conArr[0].offsetHeight;
          let cMaxWidth = conArr[0].offsetWidth;
          let cMaxHeight = conArr[0].offsetHeight;

          if (qx && qy && zx && zy) {
            this.cLeft = cMaxWidth * zx;
            this.cTop = cMaxHeight - (cMaxHeight * zy + 100);
            this.pLeft = pMaxWidth * qx;
            this.pTop = pMaxHeight - (pMaxHeight * qy + 100);
            this.newPdfImgs[pIndex].seal_c = true;
            this.newPdfImgs[cIndex].seal_p = true;
            console.log(this.cTop, this.pTop);
            console.log(pMaxWidth, pMaxHeight);
            console.log(cMaxWidth, cMaxHeight);
          }
          conArr.forEach((item, index) => {
            this.newPdfImgs[index].maxWidth = item.offsetWidth;
            this.newPdfImgs[index].maxHeight = item.offsetHeight;
          })
          console.log(conArr[0].offsetHeight, conArr[0].offsetWidth);
          // this.getByTemplate();
          clearTimeout(timer);

          // 公章默认位置  个人公章默认位置
          this.newPdfImgs.forEach(item => {
            item.seal_c = false;
            item.seal_p = false;
          })

          this.newPdfImgs[this.dataOption.zpage - 1].seal_c = true;
          this.cLeft = 50;
          this.cTop = 50;
          this.zpage = this.dataOption.zpage;

          this.newPdfImgs[this.dataOption.qpage - 1].seal_p = true;
          this.pLeft = 50;
          this.pTop = 50;
          this.qpage = this.dataOption.qpage;

          console.log(this.newPdfImgs);



        }
      }
    },
    // 添加公章
    handleCommandCompany(command) {
      // console.log(command);
      this.zpage = command+1;
      this.newPdfImgs.forEach(item => {
        item.seal_c = false;
      })
      this.newPdfImgs[command].seal_c = true;
      this.cLeft = 50;
      this.cTop = 50;
      console.log(this.newPdfImgs);
    },
    // 添加个人章
    handleCommandPerson(command) {
      this.qpage = command+1
      this.newPdfImgs.forEach(item => {
        item.seal_p = false;
      })
      this.newPdfImgs[command].seal_p = true;
      this.pLeft = 50;
      this.pTop = 50;
      console.log(this.newPdfImgs);
    },

    //公章位置
    receiveCoordinateCompany(data) {
      console.log(data)
      this.reqParams.zx = parseFloat(data.x);
      this.reqParams.zy = parseFloat(data.y);
      this.reqParams.zpage = (data.index + 1);
      this.reqParams.znum = this.newPdfImgs.length;
    },

    // 个人公章位置
    receiveCoordinatePerson(data) {
      console.log(data)
      this.reqParams.qx = parseFloat(data.x);
      this.reqParams.qy = parseFloat(data.y);
      this.reqParams.qpage = (data.index + 1);
      this.reqParams.qnum = this.newPdfImgs.length;
    },

    //  确定
    confirm() {
      const _this = this;
      let isSetPerson = false;
      this.newPdfImgs.forEach(item => {
        if (item.seal_p) {
          isSetPerson = true;
        }
      })
      let isSetCompany = false;
      this.newPdfImgs.forEach(item => {
        if (item.seal_c) {
          isSetCompany = true;
        }
      })
      if (!isSetPerson) {
        this.$message({
          message: '请设置个人章位置',
          type: 'warning'
        });
        return;
      }
      if (!isSetCompany) {
        this.$message({
          message: '请设置公章位置',
          type: 'warning'
        });
        return;
      }

      this.$refs.verifyPassword.open();
    },
    // 盖章
    onSeal() {
      console.log("密码验证后的contractId为", this.contractId)
      let reqData = {
        qx: this.reqParams.qx,
        qy: this.reqParams.qy,
        zx: this.reqParams.zx,
        zy: this.reqParams.zy,
        perviewList: [this.pdfPath],
        contractId: this.contractId,
        zpage: this.zpage,
        znum: this.znum,
        qpage: this.qpage,
        qnum: this.qnum
      }
      // console.log('templateId为',this.templateId);
      if (this.templateId) {
        reqData.templateId = this.templateId;
      }
      console.log("传入参数", reqData)
      this.btnLoading = true;
      const loading = this.$loading({
        lock: true,
        text: '数据提交中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let apiFunc;
      switch (this.action) {
        case 'heshihan':
          apiFunc = this.$api.heshihan;
          break;
        case 'chuzheng':
          apiFunc = this.$api.chuzixing;
          break;

        default:
          break;
      }

      apiFunc(reqData).then(res => {
        if (res.data.code === '200') {
          // 清除模板id
          this.$store.commit('makeCard/updateTemplateId', '');
          this.$message({
            message: '制证成功',
            type: 'success'
          });
          // 发送出证成功的事件
          this.close();
          eventBus.$emit('chuzhengSuccess');
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          });
        }
      }).finally(() => {
        this.btnLoading = false;
        loading.close();
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '../../../../style/mixin.less';

.box {
  height: 100%;
  width: 100%;

  .flex-box {
    .flex(center);
    flex-wrap: wrap;

    .img-view {
      flex-shrink: 0;
      width: 520px;
      margin: 20px 5px 0;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
      position: relative;

      .img {
        width: 100%;
      }

      .seal {
        width: 100px;
        height: 100px;
        position: absolute;
        box-sizing: border-box;
      }
    }
  }

  .btns {
    width: 100%;
    margin: 20px auto 0;
    .flex(center);
  }
}

.el-button--small {
  margin: 0 5px;
}

/deep/ .el-dialog__body {
  padding-top: 0;
}
</style>